export enum SupportedLanguages {
  English = "en",
  Dutch = "nl",
  French = "fr",
  Danish = "da",
}
